import React,{useEffect, useState} from "react";
import styles from './onBoardFinalStep.module.css'
import { Row } from 'react-bootstrap'
import Quote from "../../component/quoteGenerate/quote";
import NewHeader from "../NavBar/newHeader";
import { useNavigate } from "react-router-dom";
import Footer from "../../component/Footer/Footer";
import DocUpload from "../../component/DocumentPurposeUpload/DocUpload";

const OnboardFinalStep = () => {
    const[quoteSubmitted, setQuoteSubmitted] = useState(false);
    const history = useNavigate();

    const SaveExit = () => {
        history("/login");
    };
    
    // useEffect(() => {
    //     const isDocRequired =  sessionStorage.getItem('isDocRequired');
    //     if(isDocRequired === "true"){
    //         setQuoteSubmitted(true);
    //     }
    // },[])
  
    useEffect(() => {
        const nextStep = sessionStorage.getItem('nextStep');
        if(nextStep !== "quote" && nextStep !== "docUpload"){
            history('/transaction-detail')
        }else if(nextStep === "docUpload"){
            setQuoteSubmitted(true);
        }
    }, []);


    return(
        <>
        <NewHeader onClickLink={SaveExit} show={true}/>
        <div className={`container ${styles.mainContainer}`}>
        {!quoteSubmitted ? 
            <Quote setQuoteSubmitted={setQuoteSubmitted}/>
            :
            <DocUpload />
        }
        </div>
        <Footer/>
        </>
    )
}

export default OnboardFinalStep